/**
 * Product configuration model and constants
 * Defines the structure for all product documentation access
 */

export interface ProductLink {
  label: string;
  url: string;
  icon?: string;
}

export interface ProductSection {
  title: string;
  links: ProductLink[];
}

export interface ProductConfig {
  name: string;
  emoji: string;
  sections: ProductSection[];
}

/**
 * Common tools - Available globally across all products
 * These are the main tile buttons shown in the UI
 * Each tool can have multiple sections and links
 */
export interface CommonTool {
  label: string;
url?: string;
  icon?: string;
  sections: ProductSection[];
}

export const COMMON_TOOLS: CommonTool[] = [
  {
    label: 'Operations Portal',
    url:'www.google.com',
    icon: '/assets/images/www-svgrepo-com.svg',
    sections: [
      {
        title: 'Operations Portal',
        links: [
          { label: 'Development', url: 'https://operations.company.com' },
          { label: 'Test', url: 'https://operations.company.com/docs' },
          { label: 'Production', url: 'https://operations.company.com/docs' }
        ]
      }
    ]
  },
  {
    label: 'Operations Standard and Governance',
    icon: '/assets/images/standards-svgrepo-com.svg',
    sections: [
      {
        title: 'Governance',
        links: [
          { label: 'Home', url: 'https://iadb.atlassian.net/wiki/spaces/~5f1b4a7f1db40700148f0b0c/pages/3547856903/Operations+product+line+development+standards+and+governance' },
          
        ]
      }
    ]
  },
  {
    label: 'Tech Leads Training Material',
    icon: '/assets/images/learning-head-book-education-svgrepo-com.svg',
    sections: [
      {
        title: 'Materials',
        links: [
          { label: 'Home', url: 'https://idbg.sharepoint.com/sites/TTDTTO_OperationsProductFamily/Shared%20Documents/Forms/AllItems.aspx?id=%2Fsites%2FTTDTTO_OperationsProductFamily%2FShared%20Documents%2FTechLeads%20Training%20Materials&viewid=3594f92c-d87f-4eac-96aa-7a79c3df666d&newTargetListUrl=%2Fsites%2FTTDTTO_OperationsProductFamily%2FShared%20Documents&viewpath=%2Fsites%2FTTDTTO_OperationsProductFamily%2FShared%20Documents%2FForms%2FAllItems%2Easpx&ovuser=9dfb1a05-5f1d-449a-8960-62abcb479e7d%2CSERGIOMAR%40iadb%2Eorg&OR=Teams-HL&CT=1769699060969&clickparams=eyJBcHBOYW1lIjoiVGVhbXMtRGVza3RvcCIsIkFwcFZlcnNpb24iOiI0OS8yNjAxMDQwMDkyNSIsIkhhc0ZlZGVyYXRlZFVzZXIiOmZhbHNlfQ%3D%3D' },
          
        ]
      }
    ]
  },
  {
    label: 'Service Now',
    icon: '/assets/images/servicenow_logo.svg',
    sections: [
      {
        title: 'Service Now',
        links: [
          { label: 'Work Request', url: 'https://iadb.service-now.com/now/nav/ui/classic/params/target/u_work_order.do%3Fsys_id%3D-1%26sys_is_list%3Dtrue%26sys_target%3Du_work_order%26sysparm_checked_items%3D%26sysparm_fixed_query%3D%26sysparm_group_sort%3D%26sysparm_list_css%3D%26sysparm_query%3Du_client%253djavascript%253ags.getUserID()%255eactive%253dtrue%26sysparm_referring_url%3Du_work_order_list.do%253fsysparm_query%253du_client%25253Djavascript%25253Ags.getUserID%252528%252529%25255Eactive%25253Dtrue%25255EEQ%26sysparm_target%3D%26sysparm_view%3D' },
          { label: 'Service Central', url: 'https://iadb.service-now.com/sp' },

        ]
      }
    ]
  },
  {
    label: 'Enterprise Architecture Page',
    icon: '/assets/images/open-group.png',
    sections: [
      {
        title: 'Architecture',
        links: [
          { label: 'Home', url: 'https://idbg.sharepoint.com/sites/TTD/Architecture/SitePages/Enterprise-Architecture.aspx' },
        ]
      }
    ]
  },
  {
    label: 'Operations Repository',
    icon: '/assets/images/github-svgrepo-com.png',
    sections: [
      {
        title: 'GitHub',
        links: [
          { label: 'Home', url: 'https://github.com/oper-operations-core' },        ]
      }
    ]
  },
  {
    label: 'Confluence',
    icon: '/assets/images/confluence-svgrepo-com.svg',
    sections: [
      {
        title: 'Confluence',
        links: [
          { label: 'Home', url: 'https://iadb.atlassian.net' },
        ]
      }
    ]
  },
  {
    label: 'SonarQube',
    icon: '/assets/images/sonarqube-white-svgrepo-com.svg',
    sections: [
      {
        title: 'Code Quality',
        links: [
          { label: 'Home', url: 'https://senses.iadb.org/' },
        ]
      }
    ]
  },
  {
    label: 'Developer Portal',
    icon: '/assets/images/api-management.svg',
    sections: [
      {
        title: 'Developer Portal',
        links: [
          { label: 'Production', url: 'https://apis.iadb.org' },
          { label: 'Test', url: 'https://apim-np-t-idb-integration-developer-portal.iadb.org' },
          { label: 'Develop', url: 'https://apim-np-d-idb-integration-developer-portal.iadb.org' },

        ]
      }
    ]
  },
  {
    label: 'Jfrog',
    icon: '/assets/images/jfrog-svgrepo-com.svg',
    sections: [
      {
        title: 'Artifact Repository',
        links: [
          { label: 'Home', url: 'https://idbgartifacts.jfrog.io/ui/login/' },
        ]
      }
    ]
  },
  {
    label: 'Jenkins',
    icon: '/assets/images/jenkins-svgrepo-com.svg',
    sections: [
      {
        title: 'CI/CD',
        links: [
          { label: 'Home', url: 'https://jenkins.idb.iadb.org' },
        ]
      }
    ]
  },
  {
    label: 'Azure Suscriptions',
    icon: 'https://cdn-icons-png.flaticon.com/512/732/732221.png',
    sections: [
      {
        title: 'Cloud',
        links: [
          { label: 'Production', url: 'https://portal.azure.com/#blade/Microsoft_Azure_Billing/SubscriptionsBlade' },
          { label: 'Non production', url: 'https://portal.azure.com/?l=en.en-us&feature.msaljs=true#@idbg.onmicrosoft.com/resource/subscriptions/b6168328-2ee8-48f1-8186-451ed963006f/resourceGroups' },
        ]
      }
    ]
  },
  {
    label: 'Datadog',
    icon: '/assets/images/datadog-white-svgrepo-com.svg',
    sections: [
      {
        title: 'Monitoring',
        links: [
          { label: 'Home', url: 'https://app.datadoghq.com/account/login/id/c57ca823-221b-11ed-b331-da7ad0900002' },
        ]
      }
    ]
  },
  {
    label: 'Terraform Templates',
    icon: '/assets/images/terraform-svgrepo-com.svg',
    sections: [
      {
        title: 'Infrastructure',
        links: [
          { label: 'Source Code', url: 'https://bitbucket.org/iadb-prod/idb.infrastructure.core/src/master/' },
          { label: 'Artifactory', url: 'https://idbgartifacts.jfrog.io/ui/repos/tree/General/terraform_modules' },

        ]
      }
    ]
  },
  {
    label: 'LeanIX',
    icon: 'https://cdn.brandfetch.io/idCgYq5HlZ/theme/dark/logo.svg?c=1bxid64Mup7aczewSAYMX&t=1754499421338',
    sections: [
      {
        title: 'Leanix',
        links: [
          { label: 'Home', url: 'https://iadb.leanix.net' },
        ]
      }
    ]
  },
  {
    label: 'Design System',
    icon: '/assets/images/figma-svgrepo-com.svg',
    sections: [
      {
        title: 'Design',
        links: [
          { label: 'Design System', url: 'https://designsystem.iadb.org/?path=/docs/home--docs' },
        ]
      }
    ]
  },
  {
    label: 'Docupilot',
    icon: '/assets/images/docupilot.png',
    sections: [
      {
        title: 'Design',
        links: [
          { label: 'Home', url: 'https://idb.docupilot.app' },
        ]
      }
    ]
  },
  {
    label: 'Flowable Test',
    icon: '/assets/images/flowable.png',
    sections: [
      {
        title: 'Workflow',
        links: [
          { label: 'Control', url: 'https://test.idb.flowable-managed.com/control/#/dashboards' },
          { label: 'Design', url: 'https://test.idb.flowable-managed.com/design/' },
          { label: 'Work', url: 'https://test.idb.flowable-managed.com/work/' },
        ]
      }
    ]
  },
  {
    label: 'Flowable Production',
    icon: '/assets/images/flowable.png',
    sections: [
      {
        title: 'Workflow',
        links: [
          { label: 'Control', url: 'https://idb.flowable-managed.com/control/#/dashboards' },
          { label: 'Work', url: 'https://idb.flowable-managed.com/work/' },
        ]
      }
    ]
  }
];

/**
 * Product configurations
 * Add new products by extending this object with the ProductConfig interface
 */
export const PRODUCT_CONFIGS = {
  fiduciary: {
    name: 'Fiduciary Interface',
    emoji: '📋',
    sections: [
      {
        title: 'Fiduciary Interface',
        links: [
          { label: 'Architecture Diagram', url: 'https://iadb.leanix.net/iadbproduction/factsheet/Application/3b605b20-3f04-4915-9cad-7555b662c36a' },
          { label: 'LeanIX', url: 'https://iadb.leanix.net/iadbproduction/factsheet/Application/3b605b20-3f04-4915-9cad-7555b662c36a' },
          { label: 'Jira', url: 'https://iadb-ttd.atlassian.net/jira/software/c/projects/CFI/boards/317' },
          { label: 'Confluence', url: 'https://iadb.atlassian.net/wiki/spaces/FI/overview' },
          { label: 'API Docs', url: '/fiduciary/api-docs' },
          { label: 'Datadog', url: 'https://app.datadoghq.com/apm/entity/service%3Aapia-fiduciary-process?dependencyMap.showNetworkMetrics=false&env=production&fromUser=false&graphType=waterfall&groupMapByOperation=null&operationName=aspnet_core.request&panels=qson%3A%28data%3A%28%29%2Cversion%3A%210%29&shouldShowLegend=true&spanKind=server&traceQuery=&start=1769519438951&end=1769523038951&paused=false' },
          { label: 'Dashboards', url: 'https://app.datadoghq.com/dashboard/lists?q=team%3Afiduciary-interface&p=1' },
        ]
      }
    ]
  },
  'impact-management': {
    name: 'Impact Management',
    emoji: '📊',
    sections: [
      {
        title: 'Impact Management',
        links: [
          { label: 'Templates', url: '/impact/templates' },
          { label: 'Standards', url: '/impact/standards' },
          { label: 'Architecture Reviews', url: '/impact/arch-reviews' }
        ]
      }
    ]
  }
};
